import React from 'react';
import { Box, IconButton, IconButtonProps, Tooltip } from 'pounceV2';

interface HistoryToggleButtonProps extends Omit<IconButtonProps, 'icon' | 'aria-label'> {
  isOpen: boolean;
}

const HistoryToggleButtonV3: React.FC<HistoryToggleButtonProps> = ({
  isOpen,
  onClick,
  tabIndex,
  disabled = false,
  ...rest
}) => {
  return (
    <Tooltip content={isOpen ? 'Close history' : 'View history'} placement="top">
      <Box as="span">
        <IconButton
          icon="history"
          aria-label={isOpen ? 'Close history' : 'View history'}
          variant="ghost"
          size="medium"
          onClick={onClick}
          tabIndex={tabIndex}
          disabled={disabled}
          {...rest}
        />
      </Box>
    </Tooltip>
  );
};

export default React.memo(HistoryToggleButtonV3);
